import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const user = localStorage.getItem("loggedInUser")
      ? JSON.parse(localStorage.getItem("loggedInUser")!)
      : null;
    const userRole = user?.roleName || user?.type;

    const restrictedRoles = route.data?.['restrictedRoles'] as string[];
    if (restrictedRoles && userRole && restrictedRoles.includes(userRole)) {
      console.warn("RoleGuard: userRole is in restrictedRoles", restrictedRoles);
      this.router.navigate(["/department/dashboard"]);
      return false;
    }

    if (["DYDIRECTOR", "DCO", "ASO", "DIRECTOR", "MINISTER", "SUPPORT", "TROUPE", "AGENCY", "ARTIST", "ADMIN", "JURY"].includes(userRole)) {
      return true;
    } else if (!userRole) {
      console.warn("RoleGuard: no userRole, redirecting to /portal");
      this.router.navigate(["/portal"]);
      return false;
    } else {
      console.warn("RoleGuard: userRole not in allowed list, returning false");
      return false;
    }
  }
}
